import security from './security'

var menus = [
  {
    name: 'repairs',
    title: '请求',
    class: 'layui-icon-dzdt',
    icon: 'repair-icon',
    activeIcon: 'repair-icon-active',
    show: true,
    children: [
      {
        name: 'serviceRequest',
        title: '服务请求单',
        path: '/workOrder/serviceRequest',
        isLeaf: true,
        active: true,
        icon: 'service',
        show: true,
        ignore: true
      },
      {
        name: 'serviceRequestDetailForm',
        title: '客户服务请求单详情页',
        path: '/workOrder/serviceRequestDetailForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'serviceRequestForm',
        title: '客户服务请求单',
        path: '/workOrder/serviceRequestForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'siteRequestForm',
        title: '现场服务请求单',
        path: '/workOrder/siteRequestForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'thirdPartyServicesForm',
        title: '第三方服务请求单',
        path: '/workOrder/thirdPartyServicesForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'thirdPartyServicesSelfInspectionForm',
        title: '第三方服务请求自检单',
        path: '/workOrder/thirdPartyServicesSelfInspectionForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'repairManage',
        title: '请求管理',
        path: '/repairs/repairManage',
        isLeaf: true,
        active: true,
        icon: 'repairs-mng',
        show: true
      },
      {
        name: 'BrandApproveConfig',
        title: '品牌审批配置',
        path: '/system/BrandApproveConfig',
        isLeaf: true,
        children: [],
        icon: 'system-config',
        show: true
      },
      {
        name: 'KFConfig',
        title: '客服一键审批配置',
        path: '/system/KFConfig',
        isLeaf: true,
        children: [],
        icon: 'system-config',
        show: true
      },
      {
        name: 'repairMngForm',
        title: '请求管理',
        path: '/repairs/repairManageForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'repairApproveHistoryMainView',
        title: '请求审核历史',
        path: '/repairs/repairApproveHistoryMainView',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      }
    ]
  },
  {
    name: 'workOrder',
    title: '工单',
    class: 'layui-icon-dzdt',
    icon: 'workOrder-icon',
    activeIcon: 'workOrder-icon-active',
    show: true,
    children: [
      //   name: 'viewBoard', title: '看板', path: '/workOrder/viewBoard', icon: 'service', isLeaf: true, active: true, show: true
      // },
      {
        name: 'siteManage',
        title: '现场服务管理',
        path: '/workOrder/siteManage',
        isLeaf: true,
        active: true,
        icon: 'site',
        show: true,
        ignore: true
      },
      {
        name: 'siteForm',
        title: '现场服务管理详情页',
        path: '/workOrder/siteForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'signInOut',
        title: '签到签退管理',
        path: '/workOrder/signInOut',
        isLeaf: true,
        active: true,
        icon: 'inout',
        show: true
      },
      {
        name: 'signInOutForm',
        title: '签到签退管理详情页',
        path: '/workOrder/signInOutForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'backOrder',
        title: '返单管理',
        path: '/workOrder/backOrder',
        isLeaf: true,
        active: true,
        icon: 'returnOrder',
        show: true
      },
      {
        name: 'backOrderform',
        title: '返单管理详情页',
        path: '/workOrder/backOrderform',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'appraise',
        title: '评价管理',
        path: '/workOrder/appraise',
        isLeaf: true,
        active: true,
        icon: 'evaluation',
        show: true
      },
      {
        name: 'appraiseForm',
        title: '评价管理详情页',
        path: '/workOrder/appraiseForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'bpm',
        title: '工作流程管理_old',
        path: '/workOrder/bpm',
        isLeaf: true,
        active: true,
        icon: 'project',
        show: true
      },
      {
        name: 'newBpm',
        title: '工作流程管理',
        path: '/workOrder/newBpm',
        isLeaf: true,
        active: true,
        icon: 'project',
        show: true
      },
      {
        name: 'repairPart',
        title: '备件管理',
        path: '/workOrder/repairPart',
        isLeaf: true,
        active: true,
        icon: 'repairPart',
        show: true
      },
      {
        name: 'serviceRequestForm',
        title: '客户服务请求表单',
        path: '/workOrder/serviceRequestForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'siteRequestForm',
        title: '现场服务请求表单',
        path: '/workOrder/siteRequestForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'thirdPartyServicesForm',
        title: '第三方服务请求表单',
        path: '/workOrder/thirdPartyServicesForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'allForm',
        title: '服务单详情页',
        path: '/workOrder/allForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'storage',
        title: '资料库管理',
        path: '/workOrder/storage',
        isLeaf: true,
        active: true,
        icon: 'storage',
        show: true
      },
      {
        name: 'storageBrowserForm',
        title: '资料库浏览表单',
        path: '/person/storageBrowserForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'operLog',
        title: '操作日志',
        path: '/workOrder/operLog',
        isLeaf: true,
        active: true,
        icon: 'operLog',
        show: true
      }
    ]
  },
  {
    name: 'person',
    title: '配置',
    class: 'layui-icon-dzdt',
    icon: 'personnel-icon',
    activeIcon: 'personnel-icon-active',
    show: true,
    children: [
      {
        name: 'serviceProvider',
        title: '服务商管理',
        path: '/person/serviceProvider',
        isLeaf: true,
        active: true,
        icon: 'person-service',
        show: true
      },
      {
        name: 'serviceForm',
        title: '服务商表单',
        path: '/person/serviceForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'clientBrowserForm',
        title: '客户浏览表单',
        path: '/person/clientBrowserForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'client',
        title: '客户管理',
        path: '/person/client',
        isLeaf: true,
        active: true,
        icon: 'person-client',
        show: true
      },
      {
        name: 'clientForm',
        title: '客户表单',
        path: '/person/clientForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'brand',
        title: '品牌管理',
        path: '/person/brand',
        isLeaf: true,
        active: true,
        icon: 'person-brand',
        show: true
      },
      {
        name: 'brandAddForm',
        title: '品牌表单',
        path: '/person/brandAddForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'qrCodeManage',
        title: '二维码管理',
        path: '/repairs/qrCodeManage',
        isLeaf: true,
        active: true,
        icon: 'qr-code-mng',
        show: true
      },
      {
        name: 'qrCodeManageForm',
        title: '二维码管理',
        path: '/repairs/qrCodeManageForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'robotManage',
        title: '机器人管理',
        path: '/repairs/robotManage',
        isLeaf: true,
        active: true,
        icon: 'robot-mng',
        show: true
      },
      {
        name: 'robotManageForm',
        title: '机器人管理',
        path: '/repairs/robotManageForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'wxPersonManage',
        title: '企业微信人员管理',
        path: '/repairs/wxPersonManage',
        isLeaf: true,
        active: true,
        icon: 'wx-person-mng',
        show: true
      },
      {
        name: 'wxPersonManageForm',
        title: '企业微信人员管理',
        path: '/repairs/wxPersonManageForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'store',
        title: '门店管理',
        path: '/person/store',
        isLeaf: true,
        active: true,
        icon: 'person-store',
        show: true
      },
      {
        name: 'storeForm',
        title: '门店表单',
        path: '/person/storeForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      },
      {
        name: 'engineer',
        title: '工程师管理',
        path: '/person/engineer',
        isLeaf: true,
        active: true,
        icon: 'person-engineer',
        show: true
      },
      {
        name: 'manager',
        title: '项目经理管理',
        path: '/person/manager',
        isLeaf: true,
        active: true,
        icon: 'person-manager',
        show: true
      },
      {
        name: 'storeManagerManage',
        title: '店长管理',
        path: '/person/storeManagerManage',
        isLeaf: true,
        active: true,
        icon: 'store-manager-mng',
        show: true
      },
      {
        name: 'storeManagerMngForm',
        title: '店长管理',
        path: '/person/storeManagerMngForm',
        isLeaf: true,
        active: true,
        show: true,
        ignore: true
      }
    ]
  },
  {
    name: 'repairStatisticsManage',
    title: '报表',
    path: '/repairs/repairStatisticsManage',
    isLeaf: true,
    active: true,
    icon: 'statistics-icon',
    activeIcon: 'statistics-icon-active',
    show: true
  },
  {
    name: 'Statistics',
    title: '统计',
    path: '/statistics/statistics',
    isLeaf: true,
    active: true,
    icon: 'statistics-icon',
    activeIcon: 'statistics-icon-active',
    show: true
  },
  {
    name: 'xtgl',
    title: '系统',
    class: 'layui-icon-dzdt',
    icon: 'xt-icon',
    activeIcon: 'xt-icon-active',
    place: 'bottom',
    show: true,
    children: [
      {
        name: 'User',
        title: '用户管理',
        path: '/system/user',
        isLeaf: true,
        children: [],
        icon: 'user-icon',
        show: true
      },
      {
        name: 'Role',
        title: '角色管理',
        path: '/system/role',
        isLeaf: true,
        children: [],
        icon: 'role-icon',
        show: true
      },
      {
        name: 'Auth',
        title: '权限管理',
        path: '/system/auth',
        isLeaf: true,
        children: [],
        icon: 'auth-icon',
        show: true
      },
      // { name : 'Zq', title: '政区管理', path: '/system/zq', isLeaf : true, children: [], icon: 'zq-icon', show: true },
      {
        name: 'Dict',
        title: '字典管理',
        path: '/system/dict',
        isLeaf: true,
        children: [],
        icon: 'dict-icon',
        show: true
      },
      { name: 'Log', title: '登录日志', path: '/system/log', isLeaf: true, children: [], icon: 'log-icon', show: true },
      {
        name: 'LogAnalyse',
        title: '日志分析',
        path: '/system/logAnalyse',
        isLeaf: true,
        children: [],
        icon: 'loganalyse-icon',
        show: true
      }
    ]
  },
  {
    name: 'ptgl',
    title: '平台',
    class: 'layui-icon-dzdt',
    icon: 'pt-icon',
    activeIcon: 'pt-icon-active',
    place: 'bottom',
    show: true,
    children: [
      {
        name: 'Setting',
        title: '参数设置',
        path: '/platform/setting',
        isLeaf: true,
        children: [],
        icon: 'set-icon',
        show: true
      }
    ]
  },
  {
    name: 'viewBoard',
    title: '看板',
    path: '/workOrder/viewBoard',
    isLeaf: true,
    active: true,
    icon: 'viewBoard-icon',
    activeIcon: 'viewBoard-icon-active',
    show: true
  }
]
//为children设置parent属性
for (var i = 0; i < menus.length; i++) {
  var menu = menus[i]
  if (menu.children) {
    menu.children.forEach(item => (item.parent = menu))
  }
}

/*----------------------- 看板 -----------------------*/
import ViewBoard from '../components/viewBoard'
/*--------------------- 看板 end ----------------------*/
/* ****************** 工单 strat ****************** */
import serviceRequest from '../components/workOrder/serviceRequest'
import serviceRequestForm from '../components/workOrder/serviceRequest/serviceRequestForm_v2'
import serviceRequestDetailForm from '../components/workOrder/serviceRequest/serviceRequestForm'
import allForm from '../components/workOrder/detailForm/allForm'
import signInOut from '../components/workOrder/signInOut/index'
import signInOutForm from '../components/workOrder/signInOut/signInOutForm'
import siteManage from '../components/workOrder/siteManage'
import siteForm from '../components/workOrder/siteManage/siteForm'
import siteRequestForm from '../components/workOrder/siteManage/siteForm_v2'
import thirdPartyServicesForm from '../components/workOrder/siteManage/thirdPartyServicesForm'
import thirdPartyServicesSelfInspectionForm from '../components/workOrder/siteManage/thirdPartyServicesSelfInspectionForm'
import backOrder from '../components/workOrder/backOrde'
import backOrderform from '../components/workOrder/backOrde/backOrderform'
import appraise from '../components/workOrder/apprais'
import appraiseForm from '../components/workOrder/apprais/appraiseForm'
import bpm from '../components/workOrder/bpm'
import newBpm from '../components/workOrder/newBpm'
import repairPart from '../components/workOrder/repairPart'
import storage from '../components/workOrder/storage'
import operLog from '../components/workOrder/operLog'
/* ****************** 工单 end ****************** */
/* ****************** 人员 start ****************** */
import serviceProvider from '../components/person/servicePManage'
import serviceForm from '../components/person/servicePManage/serviceForm'
import client from '../components/person/clientManage'
import clientForm from '../components/person/clientManage/clientForm'
import brandAddForm from '../components/person/brandManage/brandForm'
import clientBrowserForm from '../components/person/clientManage/clientBrowserForm'
import brand from '../components/person/brandManage'
import store from '../components/person/storeManage'
import storeForm from '../components/person/storeManage/storeForm'
import storageBrowserForm from '../components/workOrder/storage/storageBrowserForm'
import engineer from '../components/person/engineerManage'
import manager from '../components/person/projectManager'
import storeManagerManage from '../components/person/storeManagerManage'
import storeManagerMngForm from '../components/person/storeManagerManage/storeManagerMngForm'
/* ****************** 人员 end ****************** */
/*----------------------- 报修 -----------------------*/
import repairManage from '../components/repairs/repairManage'
import repairMngForm from '../components/repairs/repairManage/repairMngForm'
import repairApproveHistoryMainView from '../components/repairs/repairManage/repairApproveHistoryMainView'
import qrCodeManage from '../components/repairs/qrCodeManage'
import qrCodeManageForm from '../components/repairs/qrCodeManage/qrCodeManageForm'
import robotManage from '../components/repairs/robotManage'
import robotManageForm from '../components/repairs/robotManage/robotManageForm'

import wxPersonManage from '../components/repairs/wxPersonManage'
import wxPersonManageForm from '../components/repairs/wxPersonManage/wxPersonManageForm'

import repairStatisticsManage from '../components/repairs/repairStatistics'
/*--------------------- 报修 end ----------------------*/
import newsDetails from '../components/news/details'

/*----------------------- 统计 -----------------------*/
import Statistics from '../components/statistics'
/*--------------------- 统计 end ----------------------*/
import LayuiMenu from '../components/common/LayuiMenu'

//系统管理模块
import User from '../components/ywpt/user/User' // 用户管理
import Role from '../components/ywpt/role/Role' // 角色管理
import Auth from '../components/ywpt/auth/Auth' // 权限管理
import Log from '../components/ywpt/log/Log' // 登录日志
import LogAnalyse from '../components/ywpt/log/logAnalyse' // 日志分析
import Zq from '../components/ywpt/zq/Zq' // 政区管理
import Dict from '../components/ywpt/dict/Dict' // 字典管理
import BrandApproveConfig from '../components/ywpt/systemconfig/BrandApproveConfig'
import KFConfig from '../components/ywpt/systemconfig/KFConfig'
//平台管理模块
import Setting from '../components/platform/setting/Setting' // 参数设置
import Security from '../components/platform/security/Security' // 安全设置
let components = {
  LayuiMenu,
  User,
  Role,
  Log,
  Auth,
  Dict,
  Zq,
  Setting,
  LogAnalyse,
  BrandApproveConfig,
  KFConfig,
  Security,
  ViewBoard,
  serviceRequest,
  serviceRequestDetailForm,
  siteManage,
  siteForm,
  serviceProvider,
  serviceForm,
  client,
  clientForm,
  brandAddForm,
  clientBrowserForm,
  brand,
  store,
  storeForm,
  engineer,
  manager,
  signInOut,
  signInOutForm,
  backOrder,
  backOrderform,
  appraise,
  appraiseForm,
  newsDetails,
  bpm,
  newBpm,
  serviceRequestForm,
  siteRequestForm,
  thirdPartyServicesForm,
  thirdPartyServicesSelfInspectionForm,
  repairPart,
  Statistics,
  allForm,
  storage,
  operLog,
  storeManagerManage,
  storeManagerMngForm,
  repairManage,
  repairMngForm,
  repairApproveHistoryMainView,
  storageBrowserForm,
  qrCodeManage,
  qrCodeManageForm,
  repairStatisticsManage,
  robotManage,
  robotManageForm,
  wxPersonManage,
  wxPersonManageForm,
}
export default {
  getMenuComponents: function() {
    return components
  },
  getMenuComponentByName: function(componentName) {
    return components[componentName]
  },
  getMenus: function() {
    //@Todo auth filter
    //   return menus
    return security.authFilter(menus)
  }
}



// WEBPACK FOOTER //
// ./src/support/menuConfig.js